import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getConfirmation, AuthorizationSchemeService, AuthorizationScheme } from '@mango/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'suselbeek-itemtile',
    templateUrl: './itemtile.component.html',
    styleUrls: ['./itemtile.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconButton, MatIcon]
})
export class ItemTileComponent implements OnInit {

    @Input() title: string;
    @Input() item: any;
    @Input() dtoType: string;

    authScheme: AuthorizationScheme;

    constructor(public dialog: MatDialog, private authSchemeService: AuthorizationSchemeService) { }

    @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit(): void {
        this.authScheme = this.authSchemeService.getMyScheme();
    }

    async delete() {
        let ok = await getConfirmation(this.dialog, "Verwijderen", "Weet u zeker dat u dit item wilt verwijderen?");

        if (ok) {
            this.onDelete.emit(this.item);
        }
    }

    canDelete(): boolean {
        return this.authScheme.canDelete(this.dtoType);
    }
}
